module.exports = __webpack_public_path__ + "static/media/TextIcon.de926a58.svg";